import { useTranslation } from "react-i18next";
import { CommonPageUiLayer } from "../components/CommonPageUiLayer";
import { MunicipalHistoryLeftMenuList } from "../utils/constants";



const MunicipalHistory = () => {
  const { t } = useTranslation();

  return (
    <CommonPageUiLayer leftNavsList={MunicipalHistoryLeftMenuList}>
      <div className="container">
        <div className="row">
          <div className="inner-title2">
            <h3 className="fontSizeClass">{t("Municipal_history_heading")}</h3>
          </div>
          <div className="about-head1">
            <p className="fontSizeClass">{t("Municipal_history_text")}</p>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row">
          <div
            className="about-head2"
            style={{
              height: "350px",
            }}
          >
            <p className="fontSizeClass">{t("Municipal_history_text1")}</p>
            <p className="fontSizeClass">{t("Municipal_history_text3")}</p>
            <p className="fontSizeClass">{t("Municipal_history_text4")}</p>
            <p className="fontSizeClass">{t("Municipal_history_text5")}</p>
            <p className="fontSizeClass">{t("Municipal_history_text6")}</p>
            <p className="fontSizeClass">{t("Municipal_history_text7")}</p>
            <p className="fontSizeClass">{t("Municipal_history_text8")}</p>
            <p className="fontSizeClass">{t("Municipal_history_text9")}</p>
            <p className="fontSizeClass">{t("Municipal_history_text10")}</p>
            <p className="fontSizeClass">{t("Municipal_history_text11")}</p>
            <p className="fontSizeClass">{t("Municipal_history_text12")}</p>
            <p className="fontSizeClass">{t("Municipal_history_text13")}</p>
            <p className="fontSizeClass">{t("Municipal_history_text14")}</p>
            <p className="fontSizeClass">{t("Municipal_history_text15")}</p>
            <p className="fontSizeClass">{t("Municipal_history_text16")}</p>
          </div>
        </div>
      </div>
    </CommonPageUiLayer>
  );
};

export default MunicipalHistory;
